define('vspot-angular/services/org-lists-service',[], function () {
    'use strict';

    return ['resources.OrgLists', function (OrgLists) {
        return {
            /*
             * Get a list of all the contact lists for a particular user.
             *
             * @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: {
             *                      loading: boolean, // Is the object actively getting data
             *                      status: boolean, // true if it worked, false on error
             *                      data: array_of_types
             *                  }
             */
            query: function () {
                return OrgLists.query();
            },

            get: function (listId) {
                return OrgLists.get({ id: listId });
            },

            update: function (listId, listName) {
                return OrgLists.update({ id: listId, list_name: listName });
            },

            save: function (listName) {
                return OrgLists.save({ list_name: listName });
            },

            delete: function (listId) {
                return OrgLists.delete({ id: listId });
            },

            /*
             *  Get a list of contact ids and the corresponding list ids they correspond to.
             */
            getAllMyContacts: function () {
                return OrgLists.getAllMyContacts();
            },
            /*
             *  Get a list of list ids and the corresponding contact ids they correspond to.
             */
            getAllMyLists: function () {
                return OrgLists.getAllMyLists();
            },
            /*
             *  Add a list of contacts to an existing list.
             *
             *  Input json:
             * {
             *    "list_id": 237, // list id
             *    "contacts": [   // Array of contact objects
             *    {
             *      "name": "Alice Cooper",
             *      "phone": "555-555-5555",
             *      "email": "alice@volunteerspot.com",
             *    },
             *    {
             *      "name": "Vincent Damon Furnier",
             *      "phone": "555-555-5555",
             *      "email": "furnier@volunteerspot.com",
             *    }
             *    ],
             *    "force": true  // If true, we will override any warnings that occur for contacts, and update existing contact information
             * }
             */
            addContactsToList: function (listId, contacts, force) {
                return OrgLists.addContactsToList({ list_id: listId, contacts: contacts, force: force });
            },
            /*
             *  Update a contact's info.
             *
             *  Input json:
             * {
             *    "contact_id": 1,    // Array of contact objects
             *    "name": "Alice Cooper",
             *    "phone": "555-555-5555",
             *    "email": "alice@volunteerspot.com"
             * }
             */
            updateContact: function (contact) {
                return OrgLists.updateContact(contact);
            },
            /*
             *  Remove a single contact from one or all contact lists.
             *
             *  Input json:
             * {
             *     "list_id": 237,    // list id
             *     "contact_id": 3928,   // contact id
             *     "deleteall": true  // if true delete contact from all lists, else delete from only the list id
             * }
             */
            removeContactFromList: function (listId, contactId, deleteAll) {
                return OrgLists.removeContactFromList({ list_id: listId, contact_id: contactId, deleteall: deleteAll });
            }
        };
    }];
});

